import { Notifications } from "@mui/icons-material";
import { Badge } from "@mui/material";

export default function NotificationBadge() {
  return (
    <Badge badgeContent={1} color="error">
      <Notifications color="inherit" />
    </Badge>
  );
}
